import { render } from "./sharedInbox.vue?vue&type=template&id=684203a2"
import script from "./sharedInbox.vue?vue&type=script&lang=js"
export * from "./sharedInbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__